<template>
  <div>

    <form class="evollu-form">
      <!-- Block Detail -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.block_detail') }}
        </h5>
      </div>

      <div class="row col-12" style="margin-bottom: 0 !important;">
        <!-- input name -->
        <div class="col-6 col-md-6">
          <va-input
            id="name"
            v-model="value.name"
            :label="$t('iframe.blocks_builder.block_name')"
            :placeholder="$t('iframe.blocks_builder.block_name')"
            @input="formErrors.clear('name')"
          />

          <small v-show="formErrors.has('name')" class="help text-danger">
            {{ $t(formErrors.get('name')) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input lang -->
        <div class="row col-md-6">
          <div class="col-12">
            <label class="form-label">{{ $t('iframe.table_headings.lang') }}</label>
            <multiselect
              :options="langOptions"
              id="lang"
              v-model="value.lang"
              :custom-label="opt => opt.language_key ? `${opt.emoji} ${$t(`language.${opt.language_key}`)}` : 'N/A'"
              track-by="lang"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              @input="formErrors.clear('lang')"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

            <small v-show="formErrors.has('lang')" class="help text-danger">
              {{ $t(formErrors.get('lang')) }}
            </small>
          </div>
        </div>
        <!-- --- --->
      </div>
      <!------------>

      <div class="row col-12">
        <div class="row col-md-6 ml-0">
          <div class="col-12 p-0">
            <label class="form-label">{{ $t('iframe.table_headings.client') }}</label>
            <multiselect
              :options="clientOptions"
              id="client"
              v-model="client"
              label="name"
              track-by="name"
              :disabled="clientOptions.length === 1"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>
          </div>

        </div>

        <!-- Show consent options? --->
        <div class="col-6 col-md-6 mt-4">
          <span class="select is-fullwidth is-small">
                <va-checkbox
                  :label="$t('iframe.blocks_builder.contact_block.show_consent_options')"
                  id="checkbox-show-consent-options"
                  :isCircle="true"
                  v-model="value.consent_options"/>
              </span>
        </div>
        <!--- --- --->

        <!-- input ctaText -->
        <div class="col-6 col-md-6">
          <va-input
            id="cta_text"
            v-model="value.cta_text"
            :label="$t('iframe.titles.cta_text')"
            :placeholder="$t('iframe.titles.cta_text')"
            @input="formErrors.clear('cta_text')"
          />

          <small v-show="formErrors.has('cta_text')" class="help text-danger">
            {{ $t(formErrors.get('cta_text')) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input ctaUrl -->
        <div class="col-6 col-md-6">
          <va-input
            id="cta_url"
            v-model="value.cta_url"
            :label="$t('iframe.titles.cta_url')"
            :placeholder="$t('iframe.titles.cta_url')"
            :maxlength="255"
            @input="formErrors.clear('cta_url')"
          />

          <small v-show="formErrors.has('cta_url')" class="help text-danger">
            {{ $t(formErrors.get('cta_url')) }}
          </small>
        </div>
        <!-- --- --->

        <div class="col-6 col-md-6 mt-4">
          <span class="select is-fullwidth is-small">
                <va-checkbox
                  :label="$t('iframe.blocks_builder.contact_block.open_cta_on_new_tab')"
                  id="open-cta-new-tab-checkbox"
                  :isCircle="true"
                  v-model="value.open_cta_on_new_tab"/>
              </span>
        </div>
      </div>

      <!-- Titles Section -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.title_section') }}
        </h5>
      </div>

      <div class="row col-12 mb-2">
        <!-- input title -->
        <div class="col-6 col-md-6 ">
          <va-input
            id="title"
            v-model="value.title"
            :label="$t('iframe.titles.title')"
            :placeholder="$t('iframe.titles.title')"
            @input="formErrors.clear('title')"
          />

          <small v-show="formErrors.has('title')" class="help text-danger">
            {{ $t(formErrors.get('title')) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input message -->
        <div class="col-6 col-md-6">
          <va-input
            id="message"
            type="textarea"
            :min-rows="2"
            v-model="value.message"
            :label="$t('iframe.titles.message')"
            :placeholder="$t('iframe.titles.message')"
            @input="formErrors.clear('message')"
          />

          <small v-show="formErrors.has('message')" class="help text-danger">
            {{ $t(formErrors.get('message')) }}
          </small>
        </div>
        <!-- --- --->


      </div>
      <!------------>

    </form>
  </div>
</template>

<script>
import Slider from '@/components/common/Slider'
import Errors from "@/utils/StandardErrors";
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
    Slider
  },
  props: {
    value: {
      type: Object,
      required: false
    },
    clientOptions: {
      type: Array,
      required: true,
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors()
      }
    },
  },
  data() {
    return {
      langOptions: this.$store.state.languages,
      client: {}
    }
  },
  mounted() {
    if(this.value && this.value.client_id) {
      this.value.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
      this.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
    }
  },
  watch: {
    client: function (val) {
      if (val) {
        this.value.client = val
      }
    }
  }

}
</script>

<style scoped>

</style>
